import { useLayoutEffect } from 'react';

import { useAppContext } from './Context';
import registerInterceptors from '../db/request-interceptors';

const useApp = () => {
  const { session, setError, setSession } = useAppContext();

  useLayoutEffect(() => {
    // courseId will be set by the page that has courseId in its url by calling registerInterceptors again
    registerInterceptors({
      token: session?.token ?? null,
      cluster: session?.cluster ?? null,
      universitySlug: session?.university.slug ?? null,
      courseId: null,
      setError,
      setSession,
    });
  }, [session?.token, session?.cluster, session?.university.slug, setError, setSession]);
};

export default useApp;
